import React, { FC } from "react";
import { Navigate } from "react-router-dom";
import { Sidebar } from "../../../sidebar/screens";
import { useToken } from "../../../auth/hooks";

export const AppLayout: FC<{ component: React.ReactNode }> = ({
  component,
}) => {
  const [token] = useToken();

  if (token === null) {
    return <Navigate replace to="/login" />;
  }

  return (
    <>
      <Sidebar />
      {component}
    </>
  );
};
